import { render, staticRenderFns } from "./slidetransitions.vue?vue&type=template&id=3c4c4913&scoped=true&"
import script from "./slidetransitions.vue?vue&type=script&lang=js&"
export * from "./slidetransitions.vue?vue&type=script&lang=js&"
import style0 from "./slidetransitions.vue?vue&type=style&index=0&id=3c4c4913&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4c4913",
  null
  
)

export default component.exports